module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "detail"
  }, [_c('div', {
    staticClass: "content"
  }, [(_vm.isBeginner) ? _c('div', [_c('div', {
    staticClass: "question question-beginner"
  }, [_c('div', {
    staticClass: "question-dsc"
  }, [_vm._v(_vm._s(_vm.detail.title || ''))])]), _c('div', {
    staticClass: "answer"
  }, [_c('div', {
    staticClass: "answer-dsc",
    domProps: {
      "innerHTML": _vm._s(_vm.detail.contents)
    }
  })])]) : _c('div', [_c('div', {
    staticClass: "question"
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._v("问题：")]), _c('div', {
    staticClass: "question-dsc"
  }, [_vm._v(_vm._s(_vm.detail.remark || ''))])]), _c('div', {
    staticClass: "answer"
  }, [_c('div', {
    staticClass: "title mt-45"
  }, [_vm._v("回答：")]), _c('div', {
    staticClass: "answer-dsc",
    domProps: {
      "innerHTML": _vm._s(_vm.detail.contents)
    }
  })])])]), _c('div', {
    staticClass: "evaluation"
  }, [_c('div', {
    staticClass: "header"
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._v("访问此篇文档：")]), _c('div', {
    staticClass: "num"
  }, [_vm._v(_vm._s(_vm.detail.viewsNumber || 0))])]), _c('div', {
    staticClass: "bottom"
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._v("评价此篇文档：")]), _c('div', {
    staticClass: "btns"
  }, _vm._l((_vm.btnsList), function(item) {
    return _c('img', {
      key: item.isHelpful,
      attrs: {
        "src": item.icon,
        "alt": ""
      },
      on: {
        "click": function($event) {
          _vm.handleHelpful(item)
        }
      }
    })
  }))])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-b19eeafc!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/ProductDocument/QuestionDetail.vue
// module id = 409
// module chunks = 0